import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styled from "styled-components";

function MenuButton(props) {
  const { item } = props;
  let navigate = useNavigate();
  const location = useLocation();
  const isActive = location.pathname === item.link;

  return (
    <div>
      <div
        onClick={() => {
          navigate(item.link);
        }}
        style={{ margin: "16px 0"}}
      >
        <MenuItem title={item.title} isActive={isActive}>
          <img src={item.icon} alt=""/>
          {item.title}
        </MenuItem>
      </div>
    </div>
  );
}

export default MenuButton;
const MenuItem = styled.div`
  color: ${props => props.isActive ? '#fff' : 'rgba(255, 255, 255, 0.8)'};
  display: grid;
  padding: ${props => props.isActive ? '10px 15px' : '0px 0px'};
  transition: 0.5s ease-out;
  border-radius: 10px;
  text-align: center;
  justify-items: center;
  background: ${props => props.isActive ? 'var(--radium-info-600)' : 'transparent'};
  border: ${props => props.isActive ? '0.5px solid rgba(255, 255, 255, 0.2)' : 'none'};
  box-shadow: ${props => props.isActive ? '0px 10px 20px rgba(0, 0, 0, 0.1)' : 'none'};
  :hover {
    background-color: var(--radium-info-600) !important;
    border: 0.5px solid rgba(255, 255, 255, 0.2);
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    padding: 10px 15px;
    color: #fff;
  }
`;
